'use strict';

function isNullish(v) {
    return v == null;
}

exports.isNullish = isNullish;
//# sourceMappingURL=is-nullish.cjs.map
